import "@/App.css";
import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Projects from "@/components/site/Projects";
import Manifesto from "@/components/site/Manifesto";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  useLenis();

  return (
    <div className="App grain" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Projects />
        <Manifesto />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
